export const configureUpdateCategory = (formValues, createdById) => {
  return {
    name: formValues.name,
    description: formValues.description,
    updatedOn: new Date(),
    updatedBy: createdById,
  };
};
